/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useState } from 'react';
import { Box } from 'grommet';
import { Text } from '@blend/alchemy';

import { requiredEmailValidator } from 'blb-utils/validators';
import { FormError } from 'blb-components/FormError';
import { BoxRadioButton } from 'blb-components/GrommetComponents/BoxRadioButton';
import { Field } from 'react-final-form';
import { emailInputConfig } from 'blb-inputs/common';

export type ShareType = 'OPEN' | 'CENTRALIZED';

export const ShareSettings: React.FC<{ selectedShareType: ShareType }> = ({ selectedShareType }) => {
  const [shareType, setShareType] = useState<ShareType>(selectedShareType);

  return (
    <>
      <Text.Info>Keep in mind you will not be able to change this setting once the team is created.</Text.Info>
      <BoxRadioButton
        checked={shareType === 'OPEN'}
        id="it-open-sharing"
        name="shareType"
        onClick={() => setShareType('OPEN')}
        primaryLabel="Open Sharing"
        secondaryLabel="Team member closings will be accessible to the rest of the team."
        value="OPEN"
      />
      <BoxRadioButton
        checked={shareType === 'CENTRALIZED'}
        id="it-centralized-sharing"
        name="shareType"
        onClick={() => setShareType('CENTRALIZED')}
        primaryLabel="Centralized Sharing"
        secondaryLabel="One team member shares their assignments with all members."
        value="CENTRALIZED"
      >
        <Box fill margin={{ top: 'small' }}>
          <Field
            id="it-broadcaster-email"
            {...emailInputConfig}
            disabled={false}
            name="broadcasterEmail"
            validate={requiredEmailValidator}
          />
        </Box>
      </BoxRadioButton>
      <FormError name="shareType" />
    </>
  );
};
